<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M49 5H15a2 2 0 00-2 2v50a2 2 0 002 2h34a2 2 0 002-2V7a2 2 0 00-2-2zm-1 51H16V8h32z"/><path d="M21.21 29.5h21.58A1.21 1.21 0 0044 28.29V13.71a1.21 1.21 0 00-1.21-1.21H21.21A1.21 1.21 0 0020 13.71v14.58a1.21 1.21 0 001.21 1.21zm.79-15h20v13H22zM21.15 51.5h21.7A1.16 1.16 0 0044 50.35v-13.2A1.16 1.16 0 0042.85 36h-21.7A1.16 1.16 0 0020 37.15v13.2a1.16 1.16 0 001.15 1.15zM22 38h20v11.5H22zM41 32a1 1 0 000 2h2a1 1 0 000-2z"/></svg>